import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { Guid } from "@/Common/Models/Guid";
import { SignedPrintAuthorization } from "@/Common/Models/SignedPrintAuthorization";
import { MedicationModel } from "./MedicationModel";
import { PrescriptionPrintHistory } from "./PrescriptionPrintHistory";

class PatientPrescriptionItem {
    public IsSelected: boolean;
    public EncounterId: string;
    public PrescriptionId: Guid;
    public PrescriptionDate: Date;
    public PrecribedByEmployeeId: Guid;
    public PrecribedByEmployee: Employee;
    public HasOnlyCeasedMeds: boolean;
    public isPending: boolean;
    public Medications: MedicationModel[];
    public SignedPrintAuthorizations: SignedPrintAuthorization[];
    public GeneralInstruction: string;
    public PrintHistory: readonly PrescriptionPrintHistory[];

    constructor() {
        this.IsSelected = false;
        this.HasOnlyCeasedMeds = false;
    }
}

export { PatientPrescriptionItem };
